import { growl } from "/WebInterface/new-ui/modules/toast.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import { setLanguage } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { ajax } from "/WebInterface/new-ui/assets/js/utils/ajax.js";

async function doReset() {
  const password1 = utils.encodeURILocal(_$("#password").val());
  const password2 = utils.encodeURILocal(_$("#passwordConfirm").val());
  if (password1 != password2) {
    growl(
      "Password and confirm password are not the same.", // data-i18n-key
      "Passwords do not match", // data-i18n-key
      5000,
      true
    );
    _$("#passwordConfirm").el().focus();
    return false;
  }

  const username = _$("#reset_1").val();
  const curLang = utils.storage.get("_i18n") || "en";

  const loading = new Loader({
    parentElement: "#resetFormContainer",
  });

  try {
    const resp = await ajax.call({
      data: {
        command: _$("#command").val(),
        reset_username_email: utils.encodeURILocal(username),
        password1: password1,
        password2: password2,
        resetToken: utils.encodeURILocal(_$("#resetToken").val()),
        currentURL:
          location.protocol + "//" + location.host + location.pathname,
        language: curLang,
        random: Math.random(),
      },
    });

    const xml = new DOMParser().parseFromString(resp, "text/xml");
    const result = utils.xmlToJson(xml);

    const { response } = result.commandResult;
    growl(
      "",
      utils.sanitizePure(decodeURIComponent(response)),
      5000,
      response.indexOf("ERROR: ") == 0
    );
  } catch (error) {
    growl("", utils.sanitizePure(decodeURIComponent(error)), 5000, true);
  } finally {
    loading.deleteLoader();
  }
}

async function sendResetRequest() {
  const username = _$("#reset_1").val();
  const curLang = utils.storage.get("_i18n") || "en";

  const obj = {
    command: _$("#command").val(),
    reset_username_email: utils.encodeURILocal(username),
    currentURL:
      document.location.protocol +
      "//" +
      document.location.host +
      document.location.pathname,
    language: curLang,
    random: Math.random(),
  };

  const formBody = Object.entries(obj)
    .map(
      ([key, value]) =>
        `${utils.encodeURILocal(key)}=${utils.encodeURILocal(value)}`
    )
    .join("&");

  const loading = new Loader({
    parentElement: "#resetFormContainer",
  });

  try {
    const resp = await ajax.call({
      data: formBody,
      urlEncoded: true,
      skipC2F: true,
    });
    const xml = new DOMParser().parseFromString(resp, "text/xml");
    const result = utils.xmlToJson(xml);

    const { response } = result.commandResult;

    growl(utils.sanitizePure(utils.decodeURILocal(response)), "", 5000, false);
  } catch (error) {
    if (!error) errorThrown = "Error";
    growl(utils.sanitizePure(errorThrown), "", 5000, false);
  } finally {
    loading.deleteLoader();
  }
  return false;
}

const init = () => {
  const queryString = location.search;
  const urlParams = new URLSearchParams(queryString);
  const token = urlParams.get("token");
  const username = urlParams.get("username");

  if (token) {
    _$(".resetPanel").removeClass("is-hidden");

    _$("#command").val("reset_password");
    _$("#resetToken").val(token).attr("readonly", "readonly");

    if (!username) {
      _$("#usernameFieldContainer").addClass("is-hidden");
    } else {
      _$("#reset_1").val(username).attr("readonly", true);
    }
  } else {
    if (username) {
      _$("#reset_1").val(username);
    }
  }

  _$("#btnGeneratePassword").on("click", () => {
    const generatedPassword = utils.generatePasswordBasedOnRules();
    _$("#generated_password").val(generatedPassword);
    _$("#generatePasswordPanel").removeClass("is-hidden");
  });

  _$("#usePassword").on("click", () => {
    const generatedPassword = _$("#generated_password").val();
    _$("#password,#passwordConfirm").val(generatedPassword);
  });

  _$("#cancelPassword").on("click", () => {
    _$("#generatePasswordPanel").addClass("is-hidden");
  });

  _$("#resetForm").on("submit", (e) => {
    e.preventDefault();

    if (token) {
      doReset();
    } else {
      sendResetRequest();
    }
  });
};

const applyCustomizations = () => {
  const login_page_default_theme =
    window.customizations?.login_page_default_theme;
  const brandingImagePath =
    window.brandingImagePath && utils.sanitizePure(window.brandingImagePath);

  if (
    login_page_default_theme ||
    typeof login_page_default_theme === "string"
  ) {
    _$("[data-theme]").attr("data-theme", login_page_default_theme);
    localStorage.setItem("data-theme", login_page_default_theme);
  }

  if (window.customizations?.login_page_default_language) {
    setLanguage(window.customizations?.login_page_default_language);
  }

  if (window.customizations?.login_page_show_language_selection === "false") {
    _$("w-language").remove();
  }

  if (window.customizations?.login_page_languages_to_show) {
    utils.filterLanguagesToShow(
      window.customizations?.login_page_languages_to_show
    );
  }

  if (window.customizations?.login_page_column_style === "single") {
    _$(".reset-banner-container").remove();
  } else {
    _$(".reset-banner-container").removeClass("is-hidden");
  }

  if (window.customizations?.login_page_column_style === "double-reverse") {
    _$("#page-columns").addClass("is-flex-direction-row-reverse");
  }

  if (window.customizations?.login_page_save_languages_selection === "true") {
    const selectedLanguage = _$("html").attr("lang");
    localStorage.setItem("selected-language", selectedLanguage);
  }

  if (brandingImagePath) {
    const authBanner = _$("#reset-banner");
    authBanner.attr("src", brandingImagePath);
  }
};

_$("body").ready(() => {
  init();
  applyCustomizations();

  _$("#backToLogin").on("click", () => {
    location.href = "/WebInterface/login.html";
  });
});
